// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20Tlw","controls":"styles_controls__2ltwO","charLimit":"styles_charLimit__WkGoF","input":"styles_input__2XmJE","send":"styles_send__zvoeR"};